import "./BrandStory.css";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const BrandStory = () => {
  const navigate = useNavigate();

  const handleDiscoverStory = () => {
    navigate("/our-story");
  };

  return (
    <section className="brand-story">
      <div className="container story-container">
        {/* Left Image */}
        <div className="story-image">
          <img 
            src="/assets/story/story.webp" 
            alt="Yadnya Handloom" 
            loading="lazy"
            width="600"
            height="800"
          />
        </div>

        {/* Right Content */}
        <div className="story-content">
          <span>OUR HERITAGE</span>

          <h2>Every Saree Tells A Story</h2>

          <p>
            At Yadnya Handloom, every weave reflects generations of
            craftsmanship. Our sarees are handcrafted by skilled artisans using
            traditional techniques passed down through families.
          </p>

          <p>
            From luxurious Paithani to elegant Banarasi and timeless
            Kanjivaram, every masterpiece is woven with patience, passion,
            and authenticity.
          </p>

          <button 
            onClick={handleDiscoverStory}
            className="discover-btn"
          >
            Discover Our Story
            <FaArrowRight />
          </button>
        </div>
      </div>
    </section>
  );
};

export default BrandStory;